import gql from 'graphql-tag'

export const SAVED_USER_ADDRESSES = gql`{
  myAddresses {
    addressLine2
    city
    id
    name
    postalCode
    phoneNumber
    state
    stateCode
    street
    isResidential
    hasDoorman
  }
}`
